import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, catchError, finalize, throwError } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { LoaderService } from "@mobi-office-ui";
import { environment } from "@environment/vm-admin-ui/environment";

@Injectable()
export class MainInterceptor implements HttpInterceptor {
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private loaderService: LoaderService
  ) {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loaderService.requestStarted();
    let token: string = "";
    token = sessionStorage.getItem("token") || "";
    console.log(token);
    if (token) request = request.clone({ headers: request.headers.set("Authorization", "Bearer " + token) });

    return next.handle(request).pipe(
      catchError(error => {
        if (environment.MAGIC_BELL_API && request.url.includes(environment.MAGIC_BELL_API)) return throwError(error);
        const errorMessage: string = error?.error?.message || error?.error?.error;
        switch (error?.status) {
          case 401:
            this.toastr.error("Unauthorized", "Error");
            sessionStorage.clear();
            this.router.navigate(["/login"]);
            window.location.reload();
            break;
          case 404:
            this.toastr.info(errorMessage, "Info");
            break;
          default:
            this.toastr.error(errorMessage, "Error");
        }
        return throwError(error);
      }),
      finalize(() => {
        this.loaderService.requestEnded();
      })
    );
  }
}
